'use strict';

import * as _ from 'lodash';
import angular from 'angular';
import io from 'socket.io-client';

function Socket(socketFactory, Auth) {
  'ngInject';
  // socket.io now auto-configures its connection when we ommit a connection url

  var ioSocket = io('', {
    // Send auth token on connection, you will need to DI the Auth service above
    'query': (Auth.getToken() ? ('token=' + Auth.getToken()) : ''),
    // 'query': 'token=' + Auth.getToken()
    auth: {
      token: (Auth.getToken() ? `Bearer ${Auth.getToken()}` : ''),
    },
    path: '/socket.io-client',
    transports: ["websocket"],
  });
  console.log('Creating a socket: socket.id=', ioSocket, ioSocket.id);

  var socket = socketFactory({
    ioSocket
  });

  socket.on('disconnect', function(err){
    console.log("socket:socket.on:disconnect:", err);
  });
  socket.on('connect', function(err){
    console.log("socket:socket.on:connect:", err);
  });
  socket.on('reconnect_attempt', function(err){
    console.log("socket:socket.on:reconnect_attempt:", err);
  });
  socket.on('reconnecting', function(err){
    console.log("socket:socket.on:reconnecting:", err);
  });
  socket.on('reconnect_error', function(err){
    console.log("socket:socket.on:reconnect_error:", err);
  });
  socket.on('reconnect_failed', function(err){
    console.log("socket:socket.on:reconnect_failed:", err);
  });
  socket.on('error', function(err){
    console.log("socket:socket.on:error:", err);
    // window.alert("socket:connectSocket error: URL=" + '' + ", error=" + JSON.stringify(err));
  });
  socket.on('connect_error', function(err){
    console.log("socket:socket.on:connect_error:", err);
  });
  socket.on('reconnect_error', function(err){
    console.log("socket:socket.on:reconnect_error:", err);
  });


  return {
    socket,
    ioSocket,
    /**
     * Register listeners to sync an array with updates on a model
     *
     * Takes the array we want to sync, the model name that socket updates are sent from,
     * and an optional callback function after new items are updated.
     *
     * @param {String} modelName
     * @param {Array} array
     * @param {Function} cb
     */
    syncUpdates(modelName, array, cb) {
      cb = cb || angular.noop;

      /**
       * Syncs item creation/updates on 'model:save'
       */
      socket.on(`${modelName}:save`, function(item) {
        var oldItem = _.find(array, {
          _id: item._id
        });
        var index = array.indexOf(oldItem);
        var event = 'created';

        // replace oldItem if it exists
        // otherwise just add item to the collection
        if(oldItem) {
          array.splice(index, 1, item);
          event = 'updated';
        } else {
          array.push(item);
        }

        cb(event, item, array);
      });

      /**
       * Syncs removed items on 'model:remove'
       */
      socket.on(`${modelName}:remove`, function(item) {
        var event = 'deleted';
        _.remove(array, {
          _id: item._id
        });
        cb(event, item, array);
      });
    },

    /**
     * Removes listeners for a models updates on the socket
     *
     * @param modelName
     */
    unsyncUpdates(modelName) {
      socket.removeAllListeners(`${modelName}:save`);
      socket.removeAllListeners(`${modelName}:remove`);
    }
  };
}

export default angular.module('paizacloudApp.socket', [])
  .factory('socket', Socket)
  .name;
